import Icons from '../../../Icons';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default function PaymentLabelsLeft({ title, value, icon, sport }): JSX.Element {
    return (
        <div className="flex justify-start md:justify-between text-xl text-sm-blue-primary py-1">
            <span className="font-bold italic">
                {icon && (
                    <Icons
                        className={`z-0 w-10 h-10 mr-2 sm:mr-1`}
                        src={icon}
                        alt={title}
                        width={30}
                        height={30}
                        sport={sport}
                    />
                )}
            </span>
            <span className="md:w-5/6 pl-4 md:pl-0 text-left italic">{value}</span>
        </div>
    );
}
